import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { getDateAndDayName } from 'helpers/dates'
import { FormattedMessage } from 'react-intl'

interface DateTitleProps {
    index: number
    date: string
}

const DateTitle = ({ index, date }: DateTitleProps) => (
    <Box direction="row" align="center" gap={12}>
        <Text variant="heading4" color="grayscale_900">
            <FormattedMessage id="global.day" defaultMessage="Dzień" /> {index}
        </Text>
        <Text variant="bodySmall" color="grayscale_700">
            {getDateAndDayName(date)}
        </Text>
    </Box>
)

export default DateTitle
